<template>
  <v-container>
    <loading-spinner></loading-spinner>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LiveSurvey",
  components: {},
  data: () => ({ loading: true }),

  computed: {
    ...mapGetters({})
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("survey/generateLiveSurvey", {
        surveyId: this.$route.params.id,
        id: this.$route.params.instanceId
      })
      .then(link => {
        if (link) {
          window.location.href = link;
        } else {
          this.$root.$alert(
            "Survey Closed",
            "This survey has been closed and is no longer available to take."
          );
          this.$router.push({ path: "/features/surveys" });
        }
      })
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading this survey."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  mounted() {},
  methods: {}
};
</script>
